"use client";

import * as Dialog from "@radix-ui/react-dialog";
import SignOutButton from "@/components/SignOutButton";
import "@/app/globals.css";
import { Box, Button, DialogTitle, Flex, Link, VisuallyHidden } from "@radix-ui/themes";
import Image from "next/image";
import { env } from "next-runtime-env";

export default function NoAccessToTNDialog({ open }: { open: boolean }) {
    return (
        <Dialog.Root open={open}>
            <Dialog.Portal>
                <Dialog.Overlay className="DialogOverlay" />
                <Dialog.Content
                    className="DialogContent"
                    style={{
                        borderRadius: "32px",
                        width: "auto",
                        maxWidth: "90%",
                        display: "inline-block",
                    }}>
                    <VisuallyHidden>
                        <DialogTitle>No Access to TN</DialogTitle>
                    </VisuallyHidden>
                    <Flex justify="center" align="center" gap="1" direction="column" className="h-full ">
                        <Flex justify="center" align="center">
                            <Image src="/invalidTn.png" alt="AT&T Config Portal" width={76} height={76} className="mr-2" priority={true} />
                        </Flex>

                        <Dialog.Description style={{ fontWeight: "700", fontSize: "26px" }} className="text-center py-3">
                            You don’t have access to this TN
                        </Dialog.Description>
                        <Dialog.Description style={{ fontWeight: "400", fontSize: "18px" }} className="text-center py-3">
                            Please sign in with another account
                        </Dialog.Description>

                        <Box
                            style={{
                                marginTop: 25,
                                justifyContent: "space-between",
                            }}>
                            <SignOutButton
                                style={{
                                    borderRadius: "32px",
                                    borderStyle: "solid",
                                    borderWidth: "thin",
                                    width: "220px",
                                    height: "40px",
                                }}
                                variant="outline"
                                className="mr-2 Button text-att-cobalt-blue cursor-pointer bg-white border-att-cobalt-blue"
                                text="Sign Out"
                            />

                            <Link href={env("NEXT_PUBLIC_BUSINESS_CENTER") || ""}>
                                <Button
                                    style={{
                                        borderRadius: "32px",
                                        width: "220px",
                                        height: "40px",
                                    }}
                                    className="ml-2 Button text-white cursor-pointer bg-att-cobalt-blue">
                                    Go back to Business Center
                                </Button>
                            </Link>
                        </Box>
                    </Flex>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
}
